import { Button, Col } from "antd";
import { useIntl } from "react-intl";

interface IProps {
  pageName: string;
  promoteOnClick: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export const PromoteToRoadmap = ({
  pageName,
  promoteOnClick,
  loading = false,
  disabled = false,
}: IProps): React.JSX.Element => {
  const intl = useIntl();

  return (
    <Col flex="none">
      <Button
        data-test-id={`${pageName}-promote`}
        type="primary"
        onClick={promoteOnClick}
        loading={loading}
        disabled={disabled}
      >
        {intl.formatMessage({ id: "initiative.promoteToRoadmap" })}
      </Button>
    </Col>
  );
};
